import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import ImageConverterImageListScreen from "./ImageConverterImageListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function ImageConverterMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Image Converter, Image Compressor Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/image_converter", title: "Image Compressor Online" },
    data2: { link: "/image_converter", title: "Image Converter Online" },
    data3: { link: "/image_converter", title: "Compress Images Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert images online easily. Change formats like JPG, PNG, GIF, or BMP quickly with our fast, secure, and user-friendly image converter tool."
      ></meta>
      <meta
        name="keywords"
        content="image converter, convert images online, JPG to PNG, PNG to JPG, image format converter, online image converter, GIF to JPG, BMP to JPG, image file converter, photo converter online, convert image formats, image conversion tool, online photo converter, picture format converter, image editor online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ImageConverterImageListScreen
          title={title}
        ></ImageConverterImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/*": [], // This MIME type accepts all image formats
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Image Converter website provides a powerful, fast, and secure solution to convert, resize, compress, and edit images without requiring an internet connection. Built to work fully offline, this all-in-one tool allows users to process images directly on their device, ensuring complete privacy and data protection. Whether you need to change image formats, reduce file size, or adjust dimensions, this platform delivers professional results with ease. Users can also choose to work online, making it flexible enough to function as an image converter online, online image converter, and image editor online when needed. The tool supports popular formats and advanced features, allowing users to resize images, scale images, and optimize visuals for websites, social media, and documents. Acting as both an image compressor online and an offline editor, it reduces image size while preserving quality and clarity. Ideal for designers, students, marketers, and everyday users, this website simplifies image workflows with a clean interface and high-performance processing. If you are searching for a secure image converter, a reliable image converter online, jpg to png converter, png to jpg converter, jpg to webp converter, image to grayscale converter, image compressor or an efficient way to resize images, scale images, and edit visuals using an online image converter with offline support, this platform delivers a seamless experience built for modern image management." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Image Converter"
            why_use={[
              {
                title: "Convert Images Between Multiple Formats",
                description:
                  "Our image converter allows users to change image formats like JPG, PNG, WEBP, and more for better compatibility and usage.",
              },
              {
                title: "Optimize Images for Web and Mobile",
                description:
                  "Using an image compressor online reduces image file size, helping websites and mobile apps load faster.",
              },
              {
                title: "Resize Images for Different Platforms",
                description:
                  "This image resizer helps resize images accurately for social media, websites, emails, and documents.",
              },
              {
                title: "Scale Images Without Quality Loss",
                description:
                  "Modern tools can scale images up or down while maintaining clarity, sharpness, and visual quality.",
              },
              {
                title: "Improve Website Performance and SEO",
                description:
                  "Compressed and resized images improve page speed. Using an online image converter helps boost SEO rankings.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Our image compressor reduces image file size, freeing up device and cloud storage space.",
              },
              {
                title: "Faster Sharing and Uploading",
                description:
                  "Smaller optimized images upload faster. This image converter online makes sharing quick and easy.",
              },
              {
                title: "Offline Processing for Privacy and Security",
                description:
                  "Our offline image converter and image resizer process images locally, keeping personal and professional files secure.",
              },
              {
                title: "Useful for Designers, Marketers, and Students",
                description:
                  "Professionals rely on image editor online and offline tools to prepare images for projects and presentations.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ImageConverterMain;
